module.exports = __webpack_public_path__ + "static/media/01(8).1ff9b638.jpg";